import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import { handleSnackBar, handleTopRightInfo, invokePostService, setReRender, toggleRightDrawer, setTabOnFocus, setIsDocumentClicked } from "../../../store/global/actions";
import { getCodeEditStatus, getRightDrawerStatus } from "../../../store/global/selectors";
import UndoRedoAlert from '../alerts/UndoRedoAlert';
import { getDetailsFromUrl } from '../../../services/blueprint';
import { useHistory } from 'react-router-dom';


const useStyles = makeStyles({
    button: {
        backgroundColor: 'red'
    },
    undoRedo: {
        textTransform: "none",
        margin: "0px 5px",
        color: "#2c3b4a",
        margin: 0
    },
    undoRedoDisabled: {
        textTransform: "none",
        margin: "0px 5px",
        color: "#ccc",
        margin: 0
    },
    listItem: {
        padding: "2px 16px",
        textAlign: "right"
    }
});

export default function UndoRedo({ view, disabled }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    const codeEditStatus = useSelector(getCodeEditStatus);
    const router = useHistory()

    const { slug, blueprintId, entityId } = getDetailsFromUrl();

    const [isDisabled, setIsDisabled] = useState(disabled);
    const [openUndoRedoList, setOpenUndoRedoList] = useState(false);

    const onUndo = () => {
        try {
            if (codeEditStatus) {
                dispatch(setIsDocumentClicked());
                console.log("Code edit status is true")
                return;
            }

        setIsDisabled(true);
        dispatch(handleTopRightInfo({ message: "Undo in progress..", open: true, }));
        dispatch(invokePostService('undo', { action: "undo" })).then((res) => {
            setIsDisabled(false);
            dispatch(handleTopRightInfo({ open: false }));
            if (res.status === true) {
                if (rightDrawerStatus == true) dispatch(toggleRightDrawer(false));
                dispatch(handleSnackBar({ open: true, message: res.message, severity: "success", id: res.data?._id }));
                handleScreenSwitch(res.data, "undo");
                dispatch(setReRender());
            } else {
                if (res.lastModifiedFlag === false) {
                    dispatch(setTabOnFocus(0));
                    setOpenUndoRedoList(true);
                } else {
                    if (res.code !== 254) {
                        dispatch(handleSnackBar({ open: true, message: res.message, severity: "error", id: null }));
                    }
                }
            }
        })


        } catch (error) {
            console.error(`Handling undo-action failed. ${error}`);
        }
    }

    const onRedo = () => {
        try {
            if (codeEditStatus) {
                dispatch(setIsDocumentClicked());
                console.log("Code edit status is true")
                return;
            }
       
        setIsDisabled(true);
        dispatch(handleTopRightInfo({ message: "Redo in progress..", open: true, }));
        dispatch(invokePostService('redo', { action: "redo" })).then((res) => {
            setIsDisabled(false);
            dispatch(handleTopRightInfo({ open: false }));
            if (res.status === true) {
                if (rightDrawerStatus == true) dispatch(toggleRightDrawer(false));
                dispatch(handleSnackBar({ open: true, message: res.message, severity: "success", id: res.data?._id }));
                handleScreenSwitch(res.data, "redo");
                dispatch(setReRender());
            } else {
                if (res.lastModifiedFlag === false) {
                    dispatch(setTabOnFocus(1));
                    setOpenUndoRedoList(true);
                } else {
                    if (res.code !== 254) {
                        dispatch(handleSnackBar({ open: true, message: res.message, severity: "error", id: null }));
                    }
                }
            }
        })


        } catch (error) {
            console.error(`Handling redo-action failed. ${error}`);
        }
    }

    // To handle the screen redirection when user undoing create or redoing delete action while open that entity or dependent entity
    const handleScreenSwitch = (data, action) => {
        const { main, dependencies = [] } = data?.entities || {};
        const entities = [main, ...dependencies].filter(Boolean);
        const screenSwitchFlag = entities.some(item => item.entity?._id === entityId && ((item.action === "create" && action === "undo") || (item.action === "delete" && action === "redo")));
        if (screenSwitchFlag) {
            router.push(`/blueprint/${slug}/${blueprintId}/system-model`);
        }
    }





    return (

        <>
            {view == "mobile" ?
                <>
                    <ListItem disabled={isDisabled} className={classes.listItem} button onClick={onUndo}>
                        <ListItemText primary="Undo" />
                    </ListItem>
                    <ListItem disabled={isDisabled} className={classes.listItem} button onClick={onRedo}>
                        <ListItemText primary="Redo" />
                    </ListItem>
                </>
                :
                <>
                    <Button disabled={isDisabled} id="undo-btn" onClick={onUndo} className={classes.undoRedo} endIcon={<UndoIcon />} data-ui-tour-id='tb-undo-btn'>Undo</Button>
                    <Button disabled={isDisabled} id="redo-btn" onClick={onRedo} className={classes.undoRedo} startIcon={<RedoIcon />} data-ui-tour-id='tb-redo-btn'>Redo</Button>
                </>
            }

            {openUndoRedoList && <UndoRedoAlert onClose={() => setOpenUndoRedoList(false)} />}


        </>
    );

}

